import CRUD from './CRUD';

/**
 * Provides a set of CRUD operations around API: /config.
 */
export default class ConfigurationClient extends CRUD {
	constructor() {
		super('/config', 'name');
	}

	/**
	 * Get all with optional environment filtering.
	 */
	getAll(env) {
		return this._op('get', this.uri, {
			env
		});
	}
}
